export const messages = {
  fr: {
    validate: "Valider",
    clear: "Réinitialiser",
    consideredUsage: "Usage considéré",
    site: "Site",
    offSite: "Hors site",
    usageTypology: "Typologie d'usage",
    actualTarget: "Cibles actuelles",
    usageType: "Type d'usage",
    target: "Cibles",
    onSiteTransferPathways: "Voies de transfert sur site",
    offSiteTransferPathways: "Voies de transfert hors site",
    offSiteTransfer: "Transferts hors site",
    conceptualSchemaDocument: "Schéma conceptuel initial",
    updatedConceptualSchemaDocument: "Schéma conceptuel mis à jour",
    takenInAccount: "Confirmé",
    notTakenInAccount: "Non confirmé",
    noSignificantImpact: "Aucun impact significatif",
    soil: "Sols",
    volatilization: "Volatilisation",
    inhalationIndoor: "Inhalation de composés volatils (air intérieur)",
    inhalationOutdoor: "Inhalation de composés volatils (air extérieur)",
    justification: "Justification",
    directTransfer: "Transfert direct",
    lateralTransfer: "Transfert latéral",
    contactCutane: "Contact cutané",
    soilIngestion: "Ingestion de sol",
    dustDispersion: "Envol de poussière",
    dustInhalation: "Inhalation ou ingestion de poussière",
    foliageRootTransfer: "Transfert foliaire / racinaire",
    plantAnimalIngestion: "Ingestion de végétaux autoproduits ou animaux élevés sur place",
    drinkingWaterTransfer: "Diffusion à travers les canalisations AEP",
    drinkingWaterConsumption: "Consommation d'eau potable",
    drinkingWaterIngestion: "Ingestion, contact et inhalation de vapeurs d'eau",
    infiltrationExposure: "Infiltration / Percolation",
    runoffExposure: "Ruissellement",
    inhalationVapor: "Inhalation de vapeurs",
    irrigation: "Irrigation",
    groundwaterPathwayIrrigation: "Arrosage/Irrigation",
    ingestionPlantedFood: "Ingestion de végétaux autoproduits ou animaux élevés sur place",
    waterIngestion: "Ingestion d'eau",
    fishingActivity: "Activité de pêche",
    fishIngestion: "Ingestion de poissons",
    runoff: "Ruissellement",
    groundwaterTransfer: "Transfert via les eaux souterraines",
    surfaceTransfer: "Relation nappe/rivière",
    offSiteIrrigation: "Ruissellement hors site",
    validationTitle: "Validation",
    validationText:
      "Vous êtes sur le point de modifier le schéma conceptuel initial. Cette action est irréversible et entraine la modification du schéma conceptuel mis à jour ainsi que la réinitialisation du programme prévisionnel. Voulez-vous continuer ?",
    noSignificantImpactText:
      "Vous êtes sur le point d'indiquer qu'aucun impact significatif n'a été trouvé apès investigation. Souhaitez-vous confirmer ?",
    confirm: "Confirmer",
    noSignificantImpactTitle: "Aucun impact significatif",
    information: "Information",
    discardTitle: "Réinitialisation",
    alert: "Attention",
    surfaceWater: "Eaux superficielles",
    groundwater: "Eaux souterraines",
    neededDataAlert:
      "Informations manquantes.Veuillez saisir les usages et les cibles concernés dans les pages Fiche identité et Hors site.",
    validationSuccess: "Le schéma conceptuel initial a été modifié avec succès.",
    discardText:
      "Vous êtes sur le point de réinitialiser le schéma conceptuel initial. Cette action est irréversible et entraine la réinitialisation du schéma conceptuel mis à jour ainsi que la réinitialisation du programme prévisionnel. Voulez-vous continuer ?",
    discardUpdatedText:
      "Vous êtes sur le point de réinitialiser le schéma conceptuel mis à jour. Cette action est irréversible et entraine la réinitialisation du schéma conceptuel mis à jour ainsi que la réinitialisation du programme prévisionnel. Voulez-vous continuer ?",
    volatileProductsAbsence: "Absence de produits volatils",
    soilCovering: "Recouvrement des sols (dalle béton, enrobé, terre végétale)",
    cleanTopsoilSupply: "Apport de terres végétales saines au droit des zones nues",
    noFruitsVegetables: "Interdiction de cultures de fruits et légumes sur site",
    noWellsGroundwater: "Interdiction de puits et captages d'eau souterraines au droit du site",
    castIronPipes:
      "Mise en œuvre des canalisations AEP en fonte ou placées dans des tranchées remblayées à l’aide de terre saine",
    buildingOverEntireSurface: "Création d'un bâtiment sur la surface intégrale du site",
    initialSoilPathwayDustDispersionJustificationFalse:
      "Présence de recouvrement de surface sur site",
    initialSoilPathwayFoliageRootTransferJustificationTrue:
      "Présence de potagers/arbres de fruitiers sur site",
    initialSoilPathwayFoliageRootTransferJustificationFalse:
      "Absence de potagers/arbres de fruitiers sur site",
    initialSoilPathwayDrinkingWaterTransferJustificationTrue:
      "Présence de réseaux enterrés en zone de pollution potentielle sur site",
    initialSoilPathwayDrinkingWaterTransferJustificationFalse:
      "Absence de réseaux enterrés en zone de pollution potentielle sur site",
    initialSoilPathwayDrinkingWaterTransferJustificationFalse2:
      "Remblaiement des futures tranchées par des matériaux sains",
    initialSoilPathwayInfiltrationExposureJustificationTrue: "Sols perméables au droit du site",
    initialSoilPathwayInfiltrationExposureJustificationFalse: "Sols imperméables au droit du site",
    initialSoilPathwayRunoffExposureJustificationTrue: "Ruissellements constatés sur site",
    fishingBan: "Interdiction de pêche",
    initialSoilPathwayVolatilizationJustificationTrue: "Présence de polluants volatils suspectée",
    initialSoilPathwayVolatilizationJustificationFalse:
      "Présence de polluants volatils non-suspectée",
    initialSoilPathwayDirectTransferJustificationTrue:
      "Absence de recouvrement de surface sur site",
    initialSoilPathwayDirectTransferJustificationFalse:
      "Présence de recouvrement de surface sur site",
    initialSoilPathwayDustDispersionJustificationTrue:
      "Absence de recouvrement de surface sur site",

    initialSoilPathwayRunoffExposureJustificationFalse: "Ruissellements non-constatés sur site",
    initialGroundwaterPathwayVolatilizationJustificationTrue:
      "Présence de polluants volatils suspectée",
    initialGroundwaterPathwayVolatilizationJustificationFalse:
      "Présence de polluants volatils non-suspectée",
    initialGroundwaterPathwayDirectTransferJustificationTrue:
      "Utilisation directe des eaux souterraines sur site",
    initialGroundwaterPathwayDirectTransferJustificationFalse:
      "Absence d'utilisation directe des eaux souterraines sur site",

    initialOffSiteSoilPathwayVolatilizationJustificationTrue:
      "Présence de polluants volatils suspectée",
    initialOffSiteSoilPathwayVolatilizationJustificationWithTransfer:
      "Présence de polluants volatils non-suspectée",
    initialOffSiteSoilPathwayDirectTransferJustificationTrue:
      "Absence de recouvrement de surface hors site",
    initialOffSiteSoilPathwayDirectTransferJustificationWithTransfer:
      "Présence de recouvrement de surface hors site",
    initialOffSiteSoilPathwayDustDispersionJustificationTrue:
      "Absence de recouvrement de surface hors site",
    initialOffSiteSoilPathwayDustDispersionJustificationWithTransfer:
      "Présence de recouvrement de surface hors site",
    initialOffSiteSoilPathwayFoliageRootTransferJustificationTrue:
      "Présence de potagers/arbres de fruitiers hors site",
    initialOffSiteSoilPathwayFoliageRootJustificationWithTransfer:
      "Absence de potagers/arbres de fruitiers hors site",
    initialOffSiteSoilPathwayDrinkingWaterTransferJustificationTrue:
      "Présence de réseaux enterrés en zone de pollution hors site",
    initialOffSiteSoilPathwayDrinkingWaterJustificationWithTransfer:
      "Absence de réseaux enterrés en zone de pollution hors site",
    initialOffSiteSoilPathwayInfiltrationExposureJustificationTrue: "Sols perméables hors site",
    initialGroundwaterPathwayIrrigationJustificationTrue:
      "Arrosage/abreuvage sur site depuis les eaux souterraines",
    initialGroundwaterPathwayIrrigationJustificationFalse:
      "Absence d'arrosage/abreuvage sur site depuis les eaux souterraines",
    initialSurfaceWaterPathwayVolatilizationJustificationTrue:
      "Présence de polluants volatils suspectée",
    initialSurfaceWaterPathwayVolatilizationJustificationFalse:
      "Absence d'eaux superficielles sur site",
    initialSurfaceWaterPathwayDirectTransferJustificationTrue:
      "Baignade et/ou utilisation directe sur site",
    initialSurfaceWaterPathwayDirectTransferJustificationFalse:
      "Absence d'eaux superficielles sur site",
    initialSurfaceWaterPathwayIrrigationJustificationTrue:
      "Arrosage/abreuvage sur site depuis les eaux superficielles",
    initialSurfaceWaterPathwayIrrigationJustificationFalse:
      "Absence d'eaux superficielles sur site",
    initialSurfaceWaterPathwayFishingActivityJustificationTrue: "Pêche sur site",
    initialSurfaceWaterPathwayFishingActivityJustificationFalse:
      "Absence d'eaux superficielles sur site",
    initialOffSiteSoilPathwayInfiltrationExposureJustificationWithTransfer:
      "Sols imperméables hors site",
    initialOffSiteSoilPathwayRunoffExposureJustificationTrue: "Ruissellements constatés hors site",
    initialOffSiteSoilPathwayRunoffExposureJustificationWithTransfer:
      "Ruissellements non-constatés hors site",
    initialOffSiteSoilPathwayJustificationWithoutTransfer:
      "Milieu Sol non exposé à la pollution potentielle du site",

    initialOffSiteGroundwaterPathwayIrrigationJustificationWithTransfer:
      "Absence d'arrosage/abreuvage hors site depuis les eaux souterraines",
    initialOffSiteGroundwaterPathwayJustificationWithoutTransfer:
      "Milieu Eaux souterraines non exposé à la pollution potentielle du site",

    initialOffSiteSurfaceWaterPathwayVolatilizationJustificationTrue:
      "Présence de polluants volatils suspectée",
    initialOffSiteSurfaceWaterPathwayDirectTransferJustificationTrue: "Baignade",
    initialOffSiteSurfaceWaterPathwayDirectTransferJustificationTrue2:
      "Utilisation directe hors site",
    initialOffSiteSurfaceWaterPathwayIrrigationJustificationTrue:
      "Arrosage/abreuvage hors site depuis les eaux superficielles",
    initialOffSiteSurfaceWaterPathwayFishingActivityJustificationTrue: "Pêche hors site",
    initialOffSiteSurfaceWaterPathwayJustificationWithTransfer:
      "Absence d'eaux superficielles hors site",
    initialOffSiteSurfaceWaterPathwayJustificationWithoutTransfer:
      "Milieu Eaux superficielles non exposé à la pollution potentielle du site",

    initialOffSitePathwayVolatilizationJustificationTrue:
      "Présence de polluants volatils suspectée",
    initialOffSitePathwayVolatilizationJustificationFalse:
      "Volatilisation hors site négligeable compte tenu de la diffusion dans l'air",
    initialOffSitePathwayDirectTransferJustificationTrue:
      "Sources de pollution potetielles localisées en limite de propriété",
    initialOffSitePathwayDirectTransferJustificationFalse:
      "Sources de pollution potetielles éloignées des limites de propriété",
    initialOffSiteGroundwaterPathwayVolatilizationJustificationTrue:
      "Présence de polluants volatils suspectée",
    initialOffSiteGroundwaterPathwayVolatilizationJustificationWithTransfer:
      "Présence de polluants volatils non-suspectée",
    initialOffSiteGroundwaterPathwayDirectTransferJustificationTrue:
      "Utilisation directe des eaux souterraines hors site",
    initialOffSiteGroundwaterPathwayDirectTransferJustificationWithTransfer:
      "Absence d'utilisation directe des eaux souterraines hors site",
    initialOffSiteGroundwaterPathwayIrrigationJustificationTrue:
      "Arrosage/abreuvage hors site depuis les eaux souterraines",
    initialOffSitePathwayDustDispersionJustificationTrue:
      "Absence de recouvrement de surface sur site",
    initialOffSitePathwayDustDispersionJustificationFalse:
      "Présence de recouvrement de surface sur site",
    initialOffSitePathwayGroundwaterTransferJustificationTrue:
      "Ecoulement des eaux souterraines hors site",

    initialOffSitePathwayOffSiteIrrigationJustificationFalse:
      "Ruissellements non-constatés sur site",
    initialOffSitePathwayGroundwaterTransferJustificationFalse: "Eaux souterraines peu vulnérables",
    initialOffSitePathwaySurfaceTransferJustificationTrue: "Nappe d'eaux souterraines peu profonde",
    initialOffSitePathwaySurfaceTransferJustificationFalse: "Nappe d'eaux souterraines profonde",
    initialOffSitePathwayOffSiteIrrigationJustificationTrue: "Ruissellements constatés sur site",
    vulnerabilityTitle: "Vulnérabilité",
    groundwaterLabel: "Eaux souterraines",
    surfaceWaterLabel: "Eaux superficielles",
    environmentLabel: "Environnement",
    vulnerabilityLevel: {
      low: "faiblement",
      medium: "moyennement",
      high: "fortement",
    },
    sensitivity: {
      low: "peu",
      medium: "moyennement",
      high: "fortement",
    },
    environmentLevel: {
      low: "peu vulnérable de l'environnement",
      medium: "moyennement vulnérable de l'environnement",
      high: "fortement vulnérable de l'environnement",
    },
  },

  en: {
    validate: "Validate",
    onSiteTransferPathways: "On-site transfer pathways",
    offSiteTransferPathways: "Off-site transfer pathways",
    offSiteTransfer: "Off-Site transfer",
    conceptualSchemaDocument: "Initial conceptual schema",
    updatedConceptualSchemaDocument: "Updated conceptual schema",
    takenInAccount: "Confirmed",
    notTakenInAccount: "Not confirmed",
    noSignificantImpact: "No significant impact",
    soilIngestion: "Soil ingestion",
    dustDispersion: "Dust dispersion",
    dustInhalation: "Dust inhalation or ingestion",
    foliageRootTransfer: "Foliar / root transfer",
    plantAnimalIngestion: "Ingestion of self-produced plants or animals raised on site",

    validationTitle: "Validation",
    confirm: "Confirm",
    soil: "Soils",
    volatilization: "Volatilization",
    inhalationIndoor: "Inhalation of volatile compounds (indoor air)",
    inhalationOutdoor: "Inhalation of volatile compounds (outdoor air)",
    justification: "Justification",
    directTransfer: "Direct transfer",
    lateralTransfer: "Lateral transfer",
    clear: "Reset",
    consideredUsage: "Considered usage",
    site: "Site",
    offSite: "Off-site",
    usageTypology: "Usage typology",
    actualTarget: "Actual targets",
    usageType: "Usage type",
    target: "Targets",
    contactCutane: "Cutaneous contact",
    information: "Information",
    alert: "Attention",
    discardTitle: "Reset",
    neededDataAlert:
      "Missing information. Please enter the relevant usages and targets in the Identity sheet and Off-site pages.",
    drinkingWaterTransfer: "Diffusion through drinking water pipes",
    drinkingWaterConsumption: "Drinking water consumption",
    drinkingWaterIngestion: "Ingestion, contact and inhalation of water vapors",
    infiltrationExposure: "Infiltration / Percolation",
    runoffExposure: "Runoff",
    inhalationVapor: "Inhalation of vapors",
    irrigation: "Irrigation",
    groundwaterPathwayIrrigation: "Watering/Irrigation",
    ingestionPlantedFood: "Ingestion of self-produced plants or animals raised on site",
    waterIngestion: "Water ingestion",
    fishingActivity: "Fishing activity",
    fishIngestion: "Fish ingestion",
    runoff: "Runoff",
    surfaceWater: "Surface water",
    groundwater: "Groundwater",
    groundwaterTransfer: "Transfer via groundwater",
    surfaceTransfer: "Relation between groundwater and river",
    offSiteIrrigation: "Off-site runoff",
    noSignificantImpactTitle: "No significant impact",
    validationSuccess: "The initial conceptual schema has been successfully modified.",
    discardText:
      "You are about to reset the initial conceptual schema. This action is irreversible and will result in the reset of the updated conceptual schema as well as the reset of the forecast program. Do you want to continue?",
    discardUpdatedText:
      "You are about to reset the updated conceptual schema. This action is irreversible and will result in the reset of the updated conceptual schema as well as the reset of the forecast program. Do you want to continue?",
    validationText:
      "You are about to modify the initial conceptual schema. This action is irreversible and will result in the modification of the updated conceptual schema as well as the reset of the forecast program. Do you want to continue?",
    noSignificantImpactText:
      "You are about to indicate that no significant impact was found after investigation. Do you want to confirm?",
    volatileProductsAbsence: "Absence of volatile products",
    soilCovering: "Soil covering (concrete slab, asphalt, topsoil)",
    cleanTopsoilSupply: "Supply of clean topsoil to bare areas",
    noFruitsVegetables: "Ban on growing fruits and vegetables on site",
    noWellsGroundwater: "Ban on wells and groundwater intakes on site",
    castIronPipes:
      "Use of cast iron drinking water pipes or placement in trenches backfilled with clean soil",
    buildingOverEntireSurface: "Construction of a building over the entire site surface",
    fishingBan: "Fishing ban",
    initialSoilPathwayVolatilizationJustificationTrue: "Suspected presence of volatile pollutants",
    initialSoilPathwayVolatilizationJustificationFalse:
      "No suspected presence of volatile pollutants",
    initialSoilPathwayDirectTransferJustificationTrue: "No surface cover on site",
    initialSoilPathwayDirectTransferJustificationFalse: "Surface cover present on site",
    initialSoilPathwayDustDispersionJustificationTrue: "No surface cover on site",
    initialSoilPathwayDustDispersionJustificationFalse: "Surface cover present on site",
    initialSoilPathwayFoliageRootTransferJustificationTrue:
      "Presence of vegetable gardens/fruit trees on site",
    initialSoilPathwayFoliageRootTransferJustificationFalse:
      "No vegetable gardens/fruit trees on site",
    initialSoilPathwayDrinkingWaterTransferJustificationTrue:
      "Presence of buried utilities in potentially polluted areas on site",
    initialSoilPathwayDrinkingWaterTransferJustificationFalse:
      "No buried utilities in potentially polluted areas on site",
    initialSoilPathwayDrinkingWaterTransferJustificationFalse2:
      "Backfilling of future trenches with clean materials",
    initialSoilPathwayInfiltrationExposureJustificationTrue: "Permeable soils on site",
    initialSoilPathwayInfiltrationExposureJustificationFalse: "Impermeable soils on site",
    initialSoilPathwayRunoffExposureJustificationTrue: "Runoff observed on site",
    initialSoilPathwayRunoffExposureJustificationFalse: "No runoff observed on site",

    initialGroundwaterPathwayVolatilizationJustificationTrue:
      "Suspected presence of volatile pollutants",
    initialGroundwaterPathwayVolatilizationJustificationFalse:
      "No suspected presence of volatile pollutants",
    initialGroundwaterPathwayDirectTransferJustificationTrue: "Direct use of groundwater on site",
    initialGroundwaterPathwayDirectTransferJustificationFalse:
      "No direct use of groundwater on site",
    initialGroundwaterPathwayIrrigationJustificationTrue:
      "Irrigation/livestock watering on site using groundwater",
    initialGroundwaterPathwayIrrigationJustificationFalse:
      "No irrigation/livestock watering on site using groundwater",

    initialSurfaceWaterPathwayVolatilizationJustificationTrue:
      "Suspected presence of volatile pollutants",
    initialSurfaceWaterPathwayVolatilizationJustificationFalse: "No surface water on site",
    initialSurfaceWaterPathwayDirectTransferJustificationTrue: "Swimming and/or direct use on site",
    initialSurfaceWaterPathwayDirectTransferJustificationFalse: "No surface water on site",
    initialSurfaceWaterPathwayIrrigationJustificationTrue:
      "Irrigation/livestock watering on site using surface water",
    initialSurfaceWaterPathwayIrrigationJustificationFalse: "No surface water on site",
    initialSurfaceWaterPathwayFishingActivityJustificationTrue: "Fishing on site",
    initialSurfaceWaterPathwayFishingActivityJustificationFalse: "No surface water on site",

    initialOffSiteSoilPathwayVolatilizationJustificationTrue:
      "Suspected presence of volatile pollutants",
    initialOffSiteSoilPathwayVolatilizationJustificationWithTransfer:
      "No suspected presence of volatile pollutants",
    initialOffSiteSoilPathwayDirectTransferJustificationTrue: "No surface cover off site",
    initialOffSiteSoilPathwayDirectTransferJustificationWithTransfer:
      "Surface cover present off site",
    initialOffSiteSoilPathwayDustDispersionJustificationTrue: "No surface cover off site",
    initialOffSiteSoilPathwayDustDispersionJustificationWithTransfer:
      "Surface cover present off site",
    initialOffSiteSoilPathwayFoliageRootTransferJustificationTrue:
      "Presence of vegetable gardens/fruit trees off site",
    initialOffSiteSoilPathwayFoliageRootTransferJustificationWithTransfer:
      "No vegetable gardens/fruit trees off site",
    initialOffSiteSoilPathwayDrinkingWaterJustificationTrue:
      "Presence of buried utilities in polluted area off site",
    initialOffSiteSoilPathwayDrinkingWaterJustificationWithTransfer:
      "No buried utilities in polluted area off site",
    initialOffSiteSoilPathwayInfiltrationExposureJustificationTrue: "Permeable soils off site",
    initialOffSiteSoilPathwayInfiltrationExposureJustificationWithTransfer:
      "Impermeable soils off site",
    initialOffSiteSoilPathwayRunoffExposureJustificationTrue: "Runoff observed off site",
    initialOffSiteSoilPathwayRunoffExposureJustificationWithTransfer: "No runoff observed off site",
    initialOffSiteSoilPathwayJustificationWithoutTransfer:
      "Soil environment not exposed to potential site pollution",

    initialOffSiteGroundwaterPathwayVolatilizationJustificationTrue:
      "Suspected presence of volatile pollutants",
    initialOffSiteGroundwaterPathwayVolatilizationJustificationWithTransfer:
      "No suspected presence of volatile pollutants",
    initialOffSiteGroundwaterPathwayDirectTransferJustificationTrue:
      "Direct use of groundwater off site",
    initialOffSiteGroundwaterPathwayDirectTransferJustificationWithTransfer:
      "No direct use of groundwater off site",
    initialOffSiteGroundwaterPathwayIrrigationJustificationTrue:
      "Irrigation/livestock watering off site using groundwater",
    initialOffSiteGroundwaterPathwayIrrigationJustificationWithTransfer:
      "No irrigation/livestock watering off site using groundwater",
    initialOffSiteGroundwaterPathwayJustificationWithoutTransfer:
      "Groundwater environment not exposed to potential site pollution",

    initialOffSiteSurfaceWaterPathwayVolatilizationJustificationTrue:
      "Suspected presence of volatile pollutants",
    initialOffSiteSurfaceWaterPathwayDirectTransferJustificationTrue: "Swimming",
    initialOffSiteSurfaceWaterPathwayDirectTransferJustificationTrue2: "Direct use off site",
    initialOffSiteSurfaceWaterPathwayIrrigationJustificationTrue:
      "Irrigation/livestock watering off site using surface water",
    initialOffSiteSurfaceWaterPathwayFishingActivityJustificationTrue: "Fishing off site",
    initialOffSiteSurfaceWaterPathwayJustificationWithTransfer: "No surface water off site",
    initialOffSiteSurfaceWaterPathwayJustificationWithoutTransfer:
      "Surface water environment not exposed to potential site pollution",

    initialOffSitePathwayVolatilizationJustificationTrue:
      "Suspected presence of volatile pollutants",
    initialOffSitePathwayVolatilizationJustificationFalse:
      "Off-site volatilization negligible due to air dispersion",
    initialOffSitePathwayDirectTransferJustificationTrue:
      "Potential pollution sources located at property boundary",
    initialOffSitePathwayDirectTransferJustificationFalse:
      "Potential pollution sources located far from property boundaries",
    initialOffSitePathwayDustDispersionJustificationTrue: "No surface cover on site",
    initialOffSitePathwayDustDispersionJustificationFalse: "Surface cover present on site",
    initialOffSitePathwayGroundwaterTransferJustificationTrue: "Groundwater flow off site",
    initialOffSitePathwayGroundwaterTransferJustificationFalse: "Low vulnerability of groundwater",
    initialOffSitePathwaySurfaceTransferJustificationTrue: "Shallow groundwater table",
    initialOffSitePathwaySurfaceTransferJustificationFalse: "Deep groundwater table",
    initialOffSitePathwayOffSiteIrrigationJustificationTrue: "Runoff observed on site",
    initialOffSitePathwayOffSiteIrrigationJustificationFalse: "No runoff observed on site",
    vulnerabilityTitle: "Vulnerability",
    groundwaterLabel: "Underground water",
    surfaceWaterLabel: "Surface water",
    environmentLabel: "Environment",
    vulnerabilityLevel: {
      low: "weakly",
      medium: "moderately",
      high: "highly",
    },
    sensitivity: {
      low: "low",
      medium: "moderately",
      high: "highly",
    },
    environmentLevel: {
      low: "low vulnerable environment",
      medium: "moderately vulnerable environment",
      high: "highly vulnerable environment",
    },
  },
};
